import SEO from '../components/SEO';

// Common SEO configurations for different page types

export const getSEOConfig = {
  // Home page
  home: () => ({
    title: 'VibrantCast - Discover and Connect with Amazing Artists',
    description: 'VibrantCast is a revolutionary platform connecting artists, galleries, collectors, and art enthusiasts. Discover amazing artwork, explore virtual galleries, and connect with the vibrant art community.',
    image: '/images/logo-120.png',
    keywords: 'art, artists, galleries, collectors, artwork, virtual galleries, art community, art discovery'
  }),

  // Artist profile
  artist: (artist) => ({
    title: `${artist?.full_name || artist?.first_name || 'Artist'} - Artist Profile | VibrantCast`,
    description: `Discover the amazing artwork by ${artist?.full_name || artist?.first_name || 'this talented artist'}. Explore their portfolio, biography, and connect with this artist on VibrantCast.`,
    image: artist?.profile_image || artist?.image_url || '/images/logo-120.png',
    keywords: `${artist?.full_name || artist?.first_name || 'artist'}, artist, artwork, portfolio, ${artist?.style || ''}, ${artist?.medium || ''}, art, VibrantCast`,
    author: artist?.full_name || artist?.first_name,
    type: 'profile'
  }),

  // Artwork detail
  artwork: (artwork) => ({
    title: `${artwork?.title || 'Artwork'} by ${artwork?.artist_name || 'Artist'} | VibrantCast`,
    description: `${artwork?.description || `Discover this amazing artwork by ${artwork?.artist_name || 'a talented artist'}.`} Available on VibrantCast art platform.`,
    image: artwork?.image_url || artwork?.primary_image || '/images/logo-120.png',
    keywords: `${artwork?.title || 'artwork'}, ${artwork?.artist_name || 'artist'}, art, ${artwork?.medium || ''}, ${artwork?.style || ''}, VibrantCast`,
    author: artwork?.artist_name,
    type: 'article'
  }),

  // Gallery detail
  gallery: (gallery) => ({
    title: `${gallery?.name || 'Gallery'} - Virtual Art Gallery | VibrantCast`,
    description: `Explore ${gallery?.name || 'this amazing gallery'} on VibrantCast. ${gallery?.description || 'Discover curated artwork collections and virtual exhibitions.'}`,
    image: gallery?.featured_image || gallery?.image_url || '/images/logo-120.png',
    keywords: `${gallery?.name || 'gallery'}, art gallery, virtual gallery, exhibitions, art collections, VibrantCast`,
    type: 'place'
  }),

  // Collection detail
  collection: (collection) => ({
    title: `${collection?.title || 'Art Collection'} | VibrantCast`,
    description: `${collection?.description || `Explore this curated art collection on VibrantCast.`} Discover amazing artworks and connect with artists.`,
    image: collection?.featured_image || '/images/logo-120.png',
    keywords: `${collection?.title || 'art collection'}, art, collection, curated art, VibrantCast`,
    type: 'article'
  }),

  // Event detail
  event: (event) => ({
    title: `${event?.title || 'Art Event'} | VibrantCast`,
    description: `${event?.description || `Join this exciting art event on VibrantCast.`} Connect with artists, galleries, and art enthusiasts.`,
    image: event?.featured_image || event?.image_url || '/images/logo-120.png',
    keywords: `${event?.title || 'art event'}, art event, exhibition, art show, VibrantCast`,
    type: 'event'
  }),

  // Audio artworks page
  'audio-artworks': () => ({
    title: 'Audio-Enhanced Artworks | VibrantCast',
    description: 'Experience art through sound. Discover artworks with audio explanations, music, and artist insights that bring each piece to life on VibrantCast.',
    image: '/images/logo-120.png',
    keywords: 'audio art, art with sound, artist audio, art explanations, interactive art, VibrantCast, audio-enhanced artworks'
  }),

  // Generic page
  page: (title, description, image = '/images/logo-120.png', keywords = '') => ({
    title: `${title} | VibrantCast`,
    description: description || 'Discover amazing art and connect with talented artists on VibrantCast.',
    image,
    keywords: `${keywords}, VibrantCast, art, artists, galleries`
  })
};

// Usage examples:
// import { getSEOConfig } from '../utils/seoConfig';
// 
// In component:
// <SEO {...getSEOConfig.artist(artist)} />
// <SEO {...getSEOConfig.artwork(artwork)} />
// <SEO {...getSEOConfig.page('About Us', 'Learn about VibrantCast and our mission')} />
